<template>
  <b-media vertical-align="center">
    <template #aside>
      <imgWithNoImageError
        :src="src"
        height="70px"
        width="70px"
        :class="'img-list-thumbnail'"
      />
    </template>
    <truncate-text
      :text="title"
      :width="width"
      :link="!!link"
      :to="link"
    />
  </b-media>
</template>

<script>
import imgWithNoImageError from '@/components/img-with-no-image-error.vue'
import { BMedia } from 'bootstrap-vue'
import TruncateText from './TruncateText.vue'

export default {
  name: 'TextImageCell',
  components: {
    imgWithNoImageError,
    BMedia,
    TruncateText,
  },
  props: ['image', 'text', 'link', 'textSubKey', 'width'],
  computed: {
    src() {
      return this.image ? this.createFullFileAddress(this.image) : ''
    },
    title() {
      if (this.textSubKey && this.text) {
        return this.text[this.textSubKey]
      } if (!this.textSubKey && this.text && this.text !== 'undefined undefined') {
        return this.text
      }
      return 'تعریف نشده'

      // return this.textSubKey ? this.text[this.textSubKey] : this.text;
    },
  },
  methods: {
    createFullFileAddress({
      baseUrl,
      bucketName,
      destination,
      filename,
    }) {
      return `${baseUrl + bucketName}/${destination}${filename}`
    },
  },
}
</script>
